
export const BaseSetting = {
    name: 'FelixPro',
    displayName: 'PTClean',
    appVersion: '2.0.1-25.11.20',
    defaultLanguage: 'ru',
    apiUrl:'http://78.40.108.61:8080',
  };
  